import type { Product } from '../types';

const ProductKeyToHAMSMap: Record<Product, string> = {
	['jira']: 'jira-software',
	['jira-service-management']: 'jira-servicedesk',
	['jira-product-discovery']: 'jira-product-discovery',
	['confluence']: 'confluence',
	['jira-customer-service']: 'jira-customer-service',
};

// Pre-built reverse lookup for `getProductFromHamsKey`, so the map is not rebuilt on every call.
const HAMSToProductKeyMap: Record<string, Product> = Object.fromEntries(
	(Object.entries(ProductKeyToHAMSMap) as [Product, string][]).map(([product, hamsKey]) => [
		hamsKey,
		product,
	]),
);

/**
 * When querying AGG for entitlements we need to pass through the `hamsProductKey` which is
 * a specific key used to identify the product, we're just mapping our product keys to those
 * hams keys for queries
 */
export const getHamsKey = (product: Product): string => {
	return ProductKeyToHAMSMap[product];
};

/**
 * Reverse of {@link getHamsKey}: resolves our `Product` key from a HAMS product key.
 * Surfaces that only receive a `hamsProductKey` (e.g. the edition benefits popup) use this to
 * pick the correct origin-tracing product. Unknown keys fall back to `jira-service-management`,
 * which is the only product family those surfaces are rendered for.
 */
export const getProductFromHamsKey = (hamsProductKey: string): Product => {
	return HAMSToProductKeyMap[hamsProductKey] ?? 'jira-service-management';
};
